module.exports = __webpack_public_path__ + "img/Exagono_team.488a6230.svg";